import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import { countActiveContracts } from "common/lib/paymentOptions";
import Permission from "Components/Common/Permission";
import UpdateIndividual from "../UpdateIndividual";
import DeleteModal from "Components/Common/DeleteModal";
import { deleteIndividual } from "common/services/individuals.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Header = ({
  individual,
  fetchData,
}: {
  individual: any;
  fetchData: () => {};
}) => {
  const navigate = useNavigate();
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const showUpdateModalForm = () => {
    setIsUpdateModalOpen(true);
  };

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    try {
      setDeleting(true);
      await deleteIndividual(individual?.id);

      setDeleting(false);
      setDeleteModal(false);
      navigate("/individuals");
      toast.success("Individual deleted successfully");
    } catch (e: any) {
      toast.error("Error while deleting individual");
    } finally {
      setDeleting(false);
    }
  };

  const countOfActiveContracts = countActiveContracts(individual?.payments);
  return (
    <React.Fragment>
      <Col lg={12}>
        <Card className="mt-n4 mx-n4 mb-n5">
          <div className="bg-warning-subtle">
            <CardBody className="pb-4 mb-5">
              <Row>
                <div className="col-md">
                  <Row className="align-items-center">
                    <div className="col-md-auto">
                      <div className="avatar-md mb-md-0 mb-4">
                        {/* <div className="avatar-title bg-white rounded-circle"> */}
                        <div className="avatar-md img-thumbnail rounded-circle">
                          <div className="avatar-title bg-primary-subtle rounded-circle fs-24 ">
                            <i className="ri-user-line text-primary"></i>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-md">
                      <h4 className="fw-semibold" id="ticket-title">
                        {individual?.fullName || "N/A"}
                      </h4>
                      <div className="hstack gap-3 flex-wrap">
                        <div className="text-muted">
                          <i className="ri-genderless-line align-bottom me-1"></i>{" "}
                          <span id="ticket-client">
                            {individual?.gender || "N/A"}
                          </span>
                        </div>
                        <div className="vr"></div>

                        {countOfActiveContracts > 1 && (
                          <div
                            className="badge rounded-pill bg-success fs-12"
                            id="ticket-status"
                          >
                            {countOfActiveContracts} Active Contracts
                          </div>
                        )}
                        {countOfActiveContracts === 0 && (
                          <div
                            className="badge rounded-pill bg-warning fs-12"
                            id="ticket-status"
                          >
                            No Active Contracts
                          </div>
                        )}
                        {countOfActiveContracts === 1 && (
                          <div
                            className="badge rounded-pill bg-success fs-12"
                            id="ticket-status"
                          >
                            {countOfActiveContracts} Active Contract
                          </div>
                        )}

                        {/* <div
                          className="badge rounded-pill bg-danger fs-12"
                          id="ticket-priority"
                        >
                          High
                        </div> */}
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="col-md-auto mt-md-0 mt-4">
                  <div className="hstack gap-1 flex-wrap">
                    <UncontrolledDropdown className="float-end">
                      <DropdownToggle
                        tag="a"
                        className="btn py-0 fs-13 material-shadow-none align-middle  text-primary"
                        role="button"
                      >
                        Actions
                        <i className=" ri-arrow-down-s-fill fs-16 ms-1"></i>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <Permission action="update" resource="individual">
                          <DropdownItem
                            href="#"
                            className="edit-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              showUpdateModalForm();
                            }}
                          >
                            <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                            Edit
                          </DropdownItem>
                        </Permission>
                        <Permission action="delete" resource="individual">
                          <DropdownItem
                            href="#"
                            className="remove-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setDeleteModal(true);
                            }}
                          >
                            <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                            Delete
                          </DropdownItem>
                        </Permission>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </Row>

              <UpdateIndividual
                toggle={() => setIsUpdateModalOpen((state) => !state)}
                isModalOpen={isUpdateModalOpen}
                selectedRecord={individual}
                fetchData={fetchData}
              />
              <DeleteModal
                show={deleteModal}
                onDeleteClick={() => handleDelete()}
                onCloseClick={() => setDeleteModal(false)}
                loading={deleting}
              />
            </CardBody>
          </div>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Header;
